/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiUserTasksGetLastSelectedIdParameter } from './ApiUserTasksGetLastSelectedIdParameter';
import {
    ApiUserTasksGetLastSelectedIdParameterFromJSON,
    ApiUserTasksGetLastSelectedIdParameterFromJSONTyped,
    ApiUserTasksGetLastSelectedIdParameterToJSON,
    ApiUserTasksGetLastSelectedIdParameterToJSONTyped,
} from './ApiUserTasksGetLastSelectedIdParameter';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface TicketCheckoutRequest
 */
export interface TicketCheckoutRequest {
    /**
     * 
     * @type {ApiUserTasksGetLastSelectedIdParameter}
     * @memberof TicketCheckoutRequest
     */
    eventId: ApiUserTasksGetLastSelectedIdParameter;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof TicketCheckoutRequest
     */
    quantity: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {number}
     * @memberof TicketCheckoutRequest
     */
    quotedBaseAmount: number;
    /**
     * 
     * @type {string}
     * @memberof TicketCheckoutRequest
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof TicketCheckoutRequest
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof TicketCheckoutRequest
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof TicketCheckoutRequest
     */
    phone: string | null;
    /**
     * 
     * @type {string}
     * @memberof TicketCheckoutRequest
     */
    tokenId: string;
    /**
     * 
     * @type {string}
     * @memberof TicketCheckoutRequest
     */
    idempotencyKey: string;
    /**
     * 
     * @type {string}
     * @memberof TicketCheckoutRequest
     */
    promoCode?: string | null;
}

/**
 * Check if a given object implements the TicketCheckoutRequest interface.
 */
export function instanceOfTicketCheckoutRequest(value: object): value is TicketCheckoutRequest {
    if (!('eventId' in value) || value['eventId'] === undefined) return false;
    if (!('quantity' in value) || value['quantity'] === undefined) return false;
    if (!('quotedBaseAmount' in value) || value['quotedBaseAmount'] === undefined) return false;
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('lastName' in value) || value['lastName'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('phone' in value) || value['phone'] === undefined) return false;
    if (!('tokenId' in value) || value['tokenId'] === undefined) return false;
    if (!('idempotencyKey' in value) || value['idempotencyKey'] === undefined) return false;
    return true;
}

export function TicketCheckoutRequestFromJSON(json: any): TicketCheckoutRequest {
    return TicketCheckoutRequestFromJSONTyped(json, false);
}

export function TicketCheckoutRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): TicketCheckoutRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'eventId': ApiUserTasksGetLastSelectedIdParameterFromJSON(json['eventId']),
        'quantity': ApiUserTasksGetPageParameterFromJSON(json['quantity']),
        'quotedBaseAmount': json['quotedBaseAmount'],
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'email': json['email'],
        'phone': json['phone'],
        'tokenId': json['tokenId'],
        'idempotencyKey': json['idempotencyKey'],
        'promoCode': json['promoCode'] == null ? undefined : json['promoCode'],
    };
}

export function TicketCheckoutRequestToJSON(json: any): TicketCheckoutRequest {
    return TicketCheckoutRequestToJSONTyped(json, false);
}

export function TicketCheckoutRequestToJSONTyped(value?: TicketCheckoutRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'eventId': ApiUserTasksGetLastSelectedIdParameterToJSON(value['eventId']),
        'quantity': ApiUserTasksGetPageParameterToJSON(value['quantity']),
        'quotedBaseAmount': value['quotedBaseAmount'],
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'email': value['email'],
        'phone': value['phone'],
        'tokenId': value['tokenId'],
        'idempotencyKey': value['idempotencyKey'],
        'promoCode': value['promoCode'],
    };
}

